module.exports = __webpack_public_path__ + "img/userLogo.b670726d.png";